import { render, staticRenderFns } from "./ImportDayOfServices.vue?vue&type=template&id=0f60f48f&scoped=true"
import script from "./ImportDayOfServices.vue?vue&type=script&lang=js"
export * from "./ImportDayOfServices.vue?vue&type=script&lang=js"
import style0 from "./ImportDayOfServices.vue?vue&type=style&index=0&id=0f60f48f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60f48f",
  null
  
)

export default component.exports